import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';

import * as yup from 'yup';

export interface DealStatusFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Deal creation date and time */
  created: Date;
  /** Deal last update date and time */
  updated: Date;
  /** Status display name */
  name: string;
  /** Display color */
  color: string;
  /** Is status "active" (need for filters) */
  active: boolean;
}

export const DealStatusFindDto = SerdeDtoClass.create<DealStatusFindInterface>(BusinessDtoKeysEnum.DEAL_STATUS_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлён',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Имя',
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет',
    serializer: yup.string(),
  },
  active: {
    label: 'Активный',
    serializer: yup.boolean(),
  },
});
